import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import {FORMS, MODULES} from "../../../const";
import Dropdown from "../../input/Dropdown";
import {
    getBulkDropdownData,
    getFieldValuesByTableAndId,
    getOtherRefSearchDropdown,
    getTextByValueAndKey
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import {vehicleAssignmentSearch} from "../../../api/jobApi";
import Input from "../../input/Input";
import Button from "../../input/Button";
import {ActiveCellStyle, ResizableScrollingTextRenderer, StatusCellStyle} from "../../renderer/StyleRenderer";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import Grid from "../../Grid";
import {stakeholderVehicleValidation} from "../../validations/StakeholderVehicleCreation";
import useUserCompany from "../../../hooks/useUserCompany";
const FORM = FORMS.STAKEHOLDER.STK_VEH.form;

const StakeholderVehicleForm = forwardRef(
    ({dropdown ,isLoading, currentValues, editMode }, ref) => {
        const userCompany = useUserCompany();
        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
        );

        useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
        }, [userCompany]);

        const [stakeholderVehData, setStakeholderVehData] = useState(
            editMode
                ? {
                    stvStakeholderType : currentValues[0].stvStakeholderType,
                    stvStakeholder : currentValues[0].stvStakeholder,
                    stvStatus : 2,
                    stvActive : 1,
                }:{

                stvStakeholderType : "",
                stvStakeholder : "",
                stvVehicle : "",
                stvDescription : "",
                stvStatus : 2,
                stvActive : 1,
                stvStakeholderTypeName : "",
                stvStakeholderName : "",
                stvVehicleName: "",
                stvCompany: company,
            }
        )


        const [currentErrors, setCurrentErrors] = useState({});
        const [currentStkVeh, setCurrentStkVeh] = useState({});

        //counter
        const [stkVehCount, setStkVehCount] = useState(2);


        // flags
        const [fieldReset, setFieldReset] = useState(false);
        const [vehicleFieldReset, setVehicleFieldReset] = useState(false);
        const [buttonClicked, setButtonClicked] = useState(false);
        const [isAddLoading, setIsAddLoading] = useState(false);
        const [stakeholderType, setStakeholderType] = useState(false);
        const [stkFieldReset, setStkFieldReset] = useState(false);

        const [stkVeh, setStkVeh] = useState([]);
        const [deletedList, setDeletedList] = useState([]);

        const [stakeTypeOptions, setStakeTypeOptions] = useState([]);
        const [selectedStakeholder, setSelectedStakeholder] = useState([]);



        useEffect(() => {
            console.log("stakeholderVehData",stakeholderVehData)
        }, [stakeholderVehData]);

        useEffect(() => {
            (async () => {
                //new
                const {
                    active,
                    status,
                    stakeholder_type: stakeholderTypeOpt,
                } = await getBulkDropdownData([
                    { key: "stakeholder_type" },
                ]);
                console.log("stakeholderTypeOpt",stakeholderTypeOpt)
                setStakeTypeOptions(stakeholderTypeOpt);
            })();
        }, []);

        useEffect(() => {
            if (buttonClicked) {
                if (editMode) {
                setStakeholderVehData({
                    stvStakeholderType : currentValues[0].stvStakeholderType,
                    stvStakeholder : currentValues[0].stvStakeholder,
                    stvVehicle : "",
                    stvDescription : "",
                    stvStatus : 2,
                    stvActive : 1,
                    stvVehicleName: "",
                });
                } else {
                    setStakeholderVehData({
                        stvStakeholderType : "",
                        stvStakeholder : "",
                        stvVehicle : "",
                        stvDescription : "",
                        stvStatus : 2,
                        stvActive : 1,
                        stvStakeholderTypeName : "",
                        stvStakeholderName : "",
                        stvVehicleName: "",
                    });
                    setStkFieldReset(true);
                }
                setFieldReset(true);


                setButtonClicked(false);
                // setSearchFieldReset(true);
                // setStkFieldReset(true);
                setCurrentStkVeh({});
            }
        }, [buttonClicked]);

        useEffect(() => {
            (async () => {
                if (editMode && currentValues) {
                    let currentStkVeh = [];
                    let id = 2;
                    for (let currentValue of currentValues) {
                        console.log("currentValue",currentValue)
                        const stvStatusValue = await getTextByValueAndKey(
                            "status",
                            currentValue.stvStatus
                        );
                        const stvActiveValue = await getTextByValueAndKey(
                            "active",
                            currentValue.stvActive
                        );
                        const stkTypeValue = await getTextByValueAndKey(
                            "stakeholder_type",
                            currentValue.stvStakeholderType
                        );
                        const stakeholder = await getFieldValuesByTableAndId({
                            tableName: "masterdata.tms_m_stakeholder",
                            primaryKey: "stk_id",
                            fieldNames: "stk_name",
                            ids: currentValue.stvStakeholder,
                        });
                        const stakeholderName = stakeholder[0].field1;

                        const vehicle = await getFieldValuesByTableAndId({
                            tableName: "masterdata.tms_m_vehicle_details",
                            primaryKey: "veh_id",
                            fieldNames: "veh_vehicleno",
                            ids: currentValue.stvVehicle,
                        });
                        const vehicleName = vehicle[0].field1;
                        currentStkVeh.push({
                            ...currentValue,
                            status: stvStatusValue,
                            active: stvActiveValue,
                            stvStakeholderTypeName: stkTypeValue,
                            stvStakeholderName: stakeholderName,
                            stvVehicleName: vehicleName,
                            id,
                        });
                        ++id;
                    }
                    setStkVehCount(id);

                    setStkVeh(currentStkVeh);
                }
            })();
        }, [editMode, currentValues]);

        const onAddClick = async () => {
            setIsAddLoading(true);
            const stkVehErrors = stakeholderVehicleValidation({
                ...stakeholderVehData,
            });
            if (Object.keys(stkVehErrors).length === 0) {
                const stvStatusValue = await getTextByValueAndKey(
                    "status",
                    stakeholderVehData.stvStatus
                );
                const stvActiveValue = await getTextByValueAndKey(
                    "active",
                    stakeholderVehData.stvActive
                );
                const stkTypeValue = await getTextByValueAndKey(
                    "stakeholder_type",
                    stakeholderVehData.stvStakeholderType
                );
                const stakeholder = await getFieldValuesByTableAndId({
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldNames: "stk_name",
                    ids: stakeholderVehData.stvStakeholder,
                });
                const stakeholderName = stakeholder[0].field1;

                const vehicle = await getFieldValuesByTableAndId({
                    tableName: "masterdata.tms_m_vehicle_details",
                    primaryKey: "veh_id",
                    fieldNames: "veh_vehicleno",
                    ids: stakeholderVehData.stvVehicle,
                });
                const vehicleName = vehicle[0].field1;

                console.log("stakeholderVehData", stakeholderVehData)
                if (
                    !stakeholderVehData.stvId ||
                    stakeholderVehData.stvId === null
                ) {
                    if (!stakeholderVehData.id || stakeholderVehData.id === null) {
                        setStkVeh((prevState) => [
                            ...prevState,
                            {
                                ...stakeholderVehData,
                                status: stvStatusValue,
                                active: stvActiveValue,
                                stvStakeholderTypeName: stkTypeValue,
                                stvStakeholderName: stakeholderName,
                                stvVehicleName: vehicleName,
                                id: stkVehCount,
                            },
                        ]);
                        setStkVehCount((prevState) => ++prevState);

                    }else{
                        setStkVeh((prevState) =>
                            prevState.filter((item) => item.id !== stakeholderVehData.id)
                        );
                        setStkVeh((prevState) => [
                            ...prevState,
                            {
                                ...stakeholderVehData,
                                status: stvStatusValue,
                                active: stvActiveValue,
                                stvStakeholderTypeName: stkTypeValue,
                                stvStakeholderName: stakeholderName,
                                stvVehicleName: vehicleName,
                            },
                        ]);
                    }
                } else {
                    setStkVeh((prevState) =>
                        prevState.filter(
                            (item) => item.stvId !== stakeholderVehData.stvId
                        )
                    );

                    setStkVeh((prevState) => [
                        ...prevState,
                        {
                            ...stakeholderVehData,
                            status: stvStatusValue,
                            active: stvActiveValue,
                            stvStakeholderTypeName: stkTypeValue,
                            stvStakeholderName: stakeholderName,
                            stvVehicleName: vehicleName,
                            modified: true,
                        },
                    ]);
                }
                setButtonClicked(true);
            }
            setCurrentErrors(stkVehErrors);
            setIsAddLoading(false);
        }
        useEffect(() => {
            if (Object.keys(currentStkVeh).length > 0) {
                if (editMode) {
                    console.log("currentStkVeh edit",currentStkVeh)
                    setStakeholderVehData({
                        ...currentStkVeh,
                    });
                } else {
                    console.log("currentStkVeh",currentStkVeh)
                    setStakeholderVehData({
                        ...currentStkVeh,
                    });
                }
            }
        }, [editMode, currentStkVeh]);

        useEffect(() => {
            (async () => {
                const selectedStakeholder = await getTextByValueAndKey(
                    "stakeholder_type",
                    stakeholderType
                );
                setSelectedStakeholder(selectedStakeholder);
            })();
        }, [stakeholderType]);

        useImperativeHandle(ref, () => ({
            getData: () => {
                if (editMode) {
                    const updateState = {
                        modified: [],
                        created: [],
                        unmodified: [],
                        deleted: deletedList,
                    };
                    stkVeh.forEach((stv) => {
                        if (stv.stvId && stv.stvId !== null) {
                            if (stv.modified) {
                                updateState.modified.push(stv);
                            } else {
                                updateState.unmodified.push(stv);
                            }
                        } else {
                            updateState.created.push(stv);
                        }
                    });
                    return updateState;
                }else {
                    return stkVeh;
                }
            },
            resetForm: () => {
                setButtonClicked(true);
                setStkVeh([]);
            },
        }));

        return(
            <>
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form
                        className="ui form"
                        style={{overflowY: "auto", height: "75vh"}}
                    >
                        <div className="ui segment">
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Type"
                                    error={currentErrors.stvStakeholderType}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="typ_type"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { stvStakeholderType: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="(Consignee/Customer/Transporter)"
                                    options={stakeTypeOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehData.stvStakeholderType}
                                    onChange={(e, data) => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvStakeholderType: data.value,
                                        }));
                                        setStakeholderType(data.value)
                                        setStkFieldReset(true);
                                    }}
                                    disabled={editMode}
                                />
                                <SearchDropdown

                                    required={true}
                                    editMode={editMode}
                                    multiGrid={true}
                                    multiGridCurrentValue={stakeholderVehData.stvStakeholderName}
                                    reset={stkFieldReset}
                                    setReset={setStkFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvStakeholder: null,
                                        }));
                                    }}
                                    onResultSelect={(data) =>
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvStakeholder: data,
                                        }))
                                    }
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: selectedStakeholder,
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_stakeholder",
                                        primaryKey: "stk_id",
                                        fieldName: "stk_name",
                                        id: stakeholderVehData.stvStakeholder,
                                    }}
                                    error={currentErrors.stvStakeholder}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { stvStakeholder: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    label="Stakeholder"
                                    disabled={editMode}
                                />
                            </div>
                            <div className="two fields">
                                <SearchDropdown
                                    required={true}
                                    editMode={editMode}
                                    reset={fieldReset}
                                    setReset={setFieldReset}
                                    multiGrid={true}
                                    multiGridCurrentValue={stakeholderVehData.stvVehicleName}
                                    clearable={true}
                                    onClear={() => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvVehicle: null,

                                        }));
                                    }}
                                    onResultSelect={(data) => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvVehicle: data,
                                            // stvVehicleName: data.title.split(" |")[0]
                                        }));
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "vehicle",
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_vehicle_details",
                                        primaryKey: "veh_id",
                                        fieldName: "veh_vehicleno",
                                        id: stakeholderVehData.stvVehicle,
                                    }}
                                    label="Vehicle"
                                    error={currentErrors.stvVehicle}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { stvVehicle: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                />
                                <Input
                                    label="Description"
                                    name="stvDescription"
                                    value={stakeholderVehData.stvDescription}
                                    onChange={(e) => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvDescription: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Status"
                                    error={currentErrors.stvStatus}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { stvStatus: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Status"
                                    options={dropdown.statusOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehData.stvStatus}
                                    onChange={(e, data) => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvStatus: data.value,
                                        }));
                                    }}
                                />
                                <Dropdown
                                    required={true}
                                    label="Active"
                                    error={currentErrors.stvActive}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const { cshActive: _, ...rest } = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Active"
                                    options={dropdown.activeOptions}
                                    style={{height: "20px"}}
                                    value={stakeholderVehData.stvActive}
                                    onChange={(e, data) => {
                                        setStakeholderVehData((prevState) => ({
                                            ...prevState,
                                            stvActive: data.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "flex-end",
                                    gap: "5px",
                                }}
                            >
                                <Button
                                    template="reset"
                                    onClick={(e) => {
                                        setButtonClicked(true);
                                    }}
                                />
                                <Button
                                    template="addOrSave"
                                    create={Object.keys(currentStkVeh).length === 0}
                                    onClick={onAddClick}
                                    isLoading={isAddLoading}
                                />
                            </div>
                            <Grid
                                heading="Stakeholder Vehicle"
                                config={[
                                    {
                                        headerName: "Stakeholder Type",
                                        field: "stvStakeholderTypeName"
                                    },
                                    {
                                        headerName: "Stakeholder",
                                        field: "stvStakeholderName",
                                        cellRenderer: ResizableScrollingTextRenderer,
                                    },
                                    {
                                        headerName: "Vehicle Details",
                                        field: "stvVehicleName",
                                        cellRenderer: ResizableScrollingTextRenderer,
                                        minWidth: 350,
                                    },
                                    {
                                        headerName: "Description",
                                        field: "stvDescription",
                                    },
                                    {
                                        headerName: "Status",
                                        field: "status",
                                        cellRenderer: StatusCellStyle,
                                    },
                                    {
                                        headerName: "Active",
                                        field: "active",
                                        cellRenderer: ActiveCellStyle,
                                    },
                                    {
                                        field: "Edit",
                                        filter: true,
                                        cellRenderer: ButtonRenderer,
                                        cellRendererParams: (params) => ({
                                            clickHandler: () => {
                                                setCurrentStkVeh(params.data);
                                            },
                                            label: "Edit",
                                        }),
                                    },
                                    {
                                        field: "Delete",
                                        filter: true,
                                        cellRenderer: ButtonRenderer,
                                        cellRendererParams: (params) => ({
                                            clickHandler: () => {
                                                if (params.data.stvId && params.data.stvId !== null) {
                                                    setDeletedList((prevState) => [
                                                        ...prevState,
                                                        params.data.stvId,
                                                    ]);
                                                }
                                                setStkVeh((prevState) =>
                                                    prevState.filter(
                                                        (stkVeh) => stkVeh.id !== params.data.id
                                                    )
                                                );
                                            },
                                            label: "Delete",
                                            className: "ui red button",
                                        }),
                                    },
                                ]}
                                content={stkVeh}
                            />
                        </div>
                    </form>
                )}
            </>
        );
    }
);
export default StakeholderVehicleForm;
